import Vue from 'vue'
import Router from 'vue-router'
// import { _local } from "@/plugins/local-storage.js"
// import Home from './views/Home.vue'

Vue.use(Router)

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
return routerPush.call(this, location).catch(error=> error)

}

const router = new Router({
  mode:'history',
  routes: [
      // 首页
      // {path: '/',name: 'home',component: () => import('./views/Home/index.vue')},
      {path: '/',name: 'home',component: () => import('./views/index.vue')},

      // 解决方案
      {path: '/solution',name: 'solution',component: () => import('./views/solution.vue')},
      {path: '/solution/detail/:id',name: 'solution_detail',component: () => import('./views/solution_detail.vue')},
      // 典型案例
      {path: '/case',name: 'case',component: () => import('./views/case.vue')},
      // {path: '/case/list/:id',name: 'case_list',component: () => import('./views/case.vue')},
      {path: '/case/detail/:id',name: 'case_detail',component: () => import('./views/case_detail.vue')},
      // 新闻动态
      {path: '/news',name: 'news',component: () => import('./views/news.vue')},
      // {path: '/news/list/:id',name: 'news_list',component: () => import('./views/news.vue')},  弃用
      {path: '/news/detail/:id',name: 'news_detail',component: () => import('./views/news_detail.vue')},
      // 人才招聘
      {path: '/job',name: 'job',component: () => import('./views/job.vue')},
      // {path: '/job/list/:id',name: 'job_list',component: () => import('./views/job.vue')},
      {path: '/job/detail/:id',name: 'job_detail',component: () => import('./views/job_detail.vue')},
      // 关于我们、公司介绍
      {path: '/about',name: 'about',component: () => import('./views/about.vue')},
      // 发展历程
      {path: '/history',name: 'history',component: () => import('./views/history.vue')},
      // 资质荣誉
      {path: '/honor',name: 'honor',component: () => import('./views/honor.vue')},
      // 联系我们
      {path: '/contact',name: 'contact',component: () => import('./views/contact.vue')},


      // 产品中心
      {path: '/product/:type',name: 'product',component: () => import('./views/product.vue')},
      {path: '/product/detail/:goods_id',name: 'product_detail',component: () => import('./views/product_detail.vue')},

      // 产品列表-按搜索
      {path: '/product/search/:info',name: 'product_search_index',component: () => import('./views/product_search.vue')},

      // 产品列表-按行业
      // {path: '/goods/industry/:info',name: 'goods_industry_index',component: () => import('./views/Home/goods/industryindex.vue')},
      // // 产品列表-按搜索
      // {path: '/goods/search/:info',name: 'goods_search_index',component: () => import('./views/Home/goods/search.vue')},


      // 购物车
      {path: '/cart/index',name: 'cart_index',component: () => import('./views/cart/index.vue')},

      // 生成订单页面  或者选择物流地址
      {path: '/order/create_order/:type/:info',name: 'create_order_index',component: () => import('./views/order/create_order.vue')},  
      // // {path: '/order/chose_pay/:order_no/:type/:info',name: 'home_chose_pay',component: () => import('./views/Home/order/chose_pay.vue')},
      // {path: '/order/chose_pay/:orderId',name: 'home_chose_pay',component: () => import('./views/Home/order/chose_pay.vue')},
      // {path: '/order/pay_success',name: 'home_pay_success',component: () => import('./views/Home/order/pay_success.vue')},

      // // 生成订货单html-zyf 2022-06-21
      // {path: '/order/pub_order',name: 'home_order_pub',component: () => import('./views/Home/order/pub_order.vue')},
      // {path: '/order/order_pdf',name: 'home_order_pdf',component: () => import('./views/Home/order/order_pdf.vue')},      
      
      // 用户中心
      {path: '/user/index',name: 'user_index',component: () => import('./views/user/index.vue'),children:[
      {path: '/user/index',name: 'user_default',component: () => import('./views/user/inquiry.vue')},
      {path: '/user/address',name: 'user_address',component: () => import('./views/user/address.vue')},
      {path: '/user/inquiry',name: 'user_inquiry',component: () => import('./views/user/inquiry.vue')},
      {path: '/user/order',name: 'user_order',component: () => import('./views/user/order.vue')},
      {path: '/user/user_info',name: 'user_info',component: () => import('./views/user/user_info.vue')},
      {path: '/user/safe',name: 'user_safe',component: () => import('./views/user/safe.vue')}, // 账号安全
        // {path: '/user/fav',name: 'home_fav',component: () => import('./views/Home/user/fav.vue')}, // 收藏关注
        // {path: '/user/fav_store',name: 'home_fav_store',component: () => import('./views/Home/user/fav_store.vue')}, // 收藏关注
        // {path: '/user/get_money_log/money',name: 'home_get_money_log',component: () => import('./views/Home/user/log.vue')}, // 资金变更日志
        // {path: '/user/get_money_log/freeze_money',name: 'home_get_money_log1',component: () => import('./views/Home/user/log_1.vue')}, // 资金变更日志
        // {path: '/user/get_money_log/integral',name: 'home_get_money_log2',component: () => import('./views/Home/user/log_2.vue')}, // 资金变更日志
        // {path: '/user/safe',name: 'home_user_safe',component: () => import('./views/Home/user/safe.vue')}, // 账号安全

        {path: '/user/safe/password',name: 'home_user_safe_password',component: () => import('./views/user/safe/password.vue')}, // 密码修改
        // {path: '/user/safe/pay_password',name: 'home_user_safe_pay_password',component: () => import('./views/Home/user//safe/pay_password.vue')}, // 支付密码修改

        // {path: '/user/user_bind',name: 'home_user_bind',component: () => import('./views/Home/user/user_bind.vue')}, // 账号绑定
        // {path: '/user/safe/card',name: 'home_user_card',component: () => import('./views/Home/user/safe/card.vue')}, // 身份认证
 
      ]},

      // 账号登录
      {path: '/user/login',name: 'user_login',component: () => import('./views/login.vue')},
      {path: '/user/register',name: 'user_register',component: () => import('./views/register.vue')},
      {path: '/user/forget_password',name: 'user_forget_password',component: () => import('./views/forget_password.vue')},
  ]
})

router.beforeEach((to, from, next)=>{
		if(to.path === '/cart/index'){
		  if(localStorage.getItem('token')){
		    next()
		  }else{
		    next('/user/login')
		  }
		}else if(to.path === '/user/login'){
		    next()
		}
		next()
})

/* router.afterEach((to, from) => {
		setTimeout(() => {
			document.title= sessionStorage.getItem('keywords')
		}, 1500)
}) */

export default router